// extracted by mini-css-extract-plugin
export default {"product_images":"ProductImages_product_images__O03BR","img":"ProductImages_img__p8bku"};